import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import formatPrice from 'utils/formatPrice';

const styles = theme => ({
  root: {
    padding: 24,
    overflow: 'hidden',
  },
  important: {
    margin: '28px -24px',
    padding: '14px 24px',
    backgroundColor: theme.palette.grey[100],
  },
  gridGutterTop: {
    marginTop: 16,
  },
});

const InsuranceViewTable = ({
  classes,
  ...otherProps
}) => {
  const phoneContacts = otherProps['Insurance Info'].Contacts.filter(contact =>
    contact.type === 'Phone' && contact.value);
  const faxContacts = otherProps['Insurance Info'].Contacts.filter(contact => 
    contact.type === 'Fax' && contact.value);
  const emailContacts = otherProps['Insurance Info'].Contacts.filter(contact => 
    contact.type === 'Email' && contact.value);
  return (
    <div className={classes.root}>
      <Grid
        container
        spacing={16}
      >
        <Grid
          item
          xs={4}
        >
          <Typography color="secondary">
            Payer name
          </Typography>
        </Grid>
        <Grid
          item
          xs={8}
        >
          <Typography>
            {otherProps['Payer Name']}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={8}
      >
        <Grid
          item
          xs={4}
        >
          <Typography color="secondary">
            Transmission method
          </Typography>
        </Grid>
        <Grid
          item
          xs={8}
        >
          <Typography>
            {otherProps['Transmission Method']}
          </Typography>
        </Grid>
      </Grid>
      <div className={classes.important}>
        <Grid
          container
          spacing={8}
        >
          <Grid
            item
            xs={6}
          >
            <Grid
              container
              spacing={16}
            >
              <Grid item>
                <Typography color="secondary">
                  Insurance ID
                </Typography>
              </Grid>
              <Grid item>
                <Typography>
                  {otherProps['Insurance ID']}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={6}
          >
            <Grid
              container
              spacing={16}
            >
              <Grid item>
                <Typography color="secondary">
                  Group ID
                </Typography>
              </Grid>
              <Grid item>
                <Typography>
                  {otherProps['Group ID']}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
      <Grid
        container
        spacing={8}
      >
        <Grid
          item
          xs={4}
        >
          <Typography color="secondary">
            Payer Type
          </Typography>
        </Grid>
        <Grid
          item
          xs={8}
        >
          <Typography>
            {(otherProps['Claim Filling Code'] && otherProps['Claim Filling Code']['Full Name'])
              && otherProps['Claim Filling Code']['Full Name']}
          </Typography>
        </Grid>
      </Grid>
      {otherProps['Order Benefits'] &&
        <Grid
          container
          spacing={8}
        >
          <Grid
            item
            xs={4}
          >
            <Typography color="secondary">
              Order of Benefits
            </Typography>
          </Grid>
          <Grid
            item
            xs={8}
          >
            <Typography>
              {otherProps['Order Benefits']}
            </Typography>
          </Grid>
        </Grid>
      }
      <Grid
        className={classes.gridGutterTop}
        container
        spacing={8}
      >
        <Grid
          item
          xs={4}
        >
          {((otherProps['Effective From'] && otherProps['Effective To'])
            || (!otherProps['Effective From'] && !otherProps['Effective To'])) &&
            <Typography color="secondary">
              Effective From / To
            </Typography>
          }
          {(otherProps['Effective From'] && !otherProps['Effective To']) &&
            <Typography color="secondary">
              Effective From
            </Typography>
          }
          {(!otherProps['Effective From'] && otherProps['Effective To']) &&
            <Typography color="secondary">
              Effective To
            </Typography>
          }
        </Grid>
        <Grid
          item
          xs={8}
        >
          {(otherProps['Effective From'] && otherProps['Effective To']) &&
            <Typography>
              {`${otherProps['Effective From']} - ${otherProps['Effective To']}`}
            </Typography>
          }
          {(otherProps['Effective From'] && !otherProps['Effective To']) &&
            <Typography>
              {otherProps['Effective From']}
            </Typography>
          }
          {(!otherProps['Effective From'] && otherProps['Effective To']) &&
            <Typography>
              {otherProps['Effective To']}
            </Typography>
          }
        </Grid>
      </Grid>
      {(otherProps['Insurance Special Date'] && otherProps['Insurance Special Date'].length > 0) && (
        <Fragment>
          {otherProps['Insurance Special Date'].map(specialDateItem => (
            <Grid
              className={classes.gridGutterTop}
              container
              spacing={8}
            >
              <Grid
                item
                xs={4}
              > 
                <Typography color="secondary">
                  {specialDateItem['Type Of Date']}
                </Typography>
              </Grid>
              <Grid
                item
                xs={8}
              >
                <Typography>
                  {specialDateItem['Special Date']}
                </Typography>
              </Grid>
            </Grid>
          ))}
        </Fragment>
      )}
      <Grid
        container
        spacing={8}
      >
        <Grid
          item
          xs={4}
        >
          <Typography color="secondary">
            Relation to Insured
          </Typography>
        </Grid>
        <Grid
          item
          xs={8}
        >
          <Typography>
            {otherProps['Relation to Insured']}
          </Typography>
        </Grid>
      </Grid>
      <div className={classes.important}>
        <Grid
          container
          spacing={8}
        >
          <Grid
            item
            xs={6}
          >
            <Grid
              container
              spacing={16}
            >
              <Grid item>
                <Typography color="secondary">
                  Copay Type
                </Typography>
              </Grid>
              <Grid item>
                <Typography>
                  {otherProps['Copay Type']}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={6}
          >
            <Grid
              container
              spacing={16}
            >
              <Grid item>
                <Typography color="secondary">
                  Copay Amount
                </Typography>
              </Grid>
              <Grid item>
                <Typography>
                  {
                    otherProps['Copay Type'] === 'Fixed'
                      ? formatPrice(otherProps['Copay Amount'])
                      : `${otherProps['Copay Amount']}%`
                  }
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
      {otherProps.Comments &&
        <Grid
          container
          spacing={8}
          direction="column"
        >
          <Grid
            item
            xs={4}
          >
            <Typography variant="caption">
              Comments
            </Typography>
          </Grid>
          <Grid
            item
            xs={8}
          >
            <Typography>
              {otherProps.Comments}
            </Typography>
          </Grid>
        </Grid>
      }
      {phoneContacts.length > 0 && (
        <Grid
          container
          spacing={8}
        >
          <Grid
            item
            xs={4}
          >
            <Typography color="secondary">
              Phone
            </Typography>
          </Grid>
          <Grid
            item
            xs={8}
          >
            {phoneContacts.map(contact => (
              <Typography key={contact.ID}>
                {contact.value}
                {contact.description ? ` - ${contact.description}` : ''}
              </Typography>
            ))}
          </Grid>
        </Grid>
      )}
      {faxContacts.length > 0 && (
        <Grid
          container
          spacing={8}
        >
          <Grid
            item
            xs={4}
          >
            <Typography color="secondary">
              Fax
            </Typography>
          </Grid>
          <Grid
            item
            xs={8}
          >
            {faxContacts.map(contact => (
              <Typography key={contact.ID}>
                {contact.value}
                {contact.description ? ` - ${contact.description}` : ''}
              </Typography>
            ))}
          </Grid>
        </Grid>
      )}
      {emailContacts.length > 0 && (
        <Grid
          container
          spacing={8}
        >
          <Grid
            item
            xs={4}
          >
            <Typography color="secondary">
              Email
            </Typography>
          </Grid>
          <Grid
            item
            xs={8}
          >
            {emailContacts.map(contact => (
              <Typography key={contact.ID}>
                {contact.value}
                {contact.description ? ` - ${contact.description}` : ''}
              </Typography>
            ))}
          </Grid>
        </Grid>
      )}
    </div>
  );
}

InsuranceViewTable.propTypes = {
  'Insurance Info': PropTypes.shape({
    'Payer Name': PropTypes.string.isRequired,
  }).isRequired,
  'Transmission Method': PropTypes.string.isRequired,
  'Insurance ID': PropTypes.string.isRequired,
  'Group ID': PropTypes.string,
  'Order Benefits': PropTypes.string,
  'Effective From': PropTypes.string,
  'Effective To': PropTypes.string,
  'Relation to Insured': PropTypes.string.isRequired,
  'Copay Type': PropTypes.string,
  'Copay Amount': PropTypes.number.isRequired,
  Comments: PropTypes.string,
  'Claim Filling Code': PropTypes.shape({
    'Full Name': PropTypes.string.isRequired,
  }),
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    important: PropTypes.string.isRequired,
    gridGutterTop: PropTypes.string.isRequired,
  }).isRequired,
};

InsuranceViewTable.defaultProps = {
  'Order Benefits': null,
  Comments: null,
  'Copay Type': null,
  'Claim Filling Code': null,
  'Group ID': null,
  'Effective From': null,
  'Effective To': null,
};

export default withStyles(styles)(InsuranceViewTable);



// WEBPACK FOOTER //
// ./src/components/patient/InsuranceViewDialog/InsuranceViewTable.js